import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 1,
  class: "animate-spin -ml-1 mr-2 h-4 w-4",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["btn", [_ctx.getButtonColor, _ctx.getButtonSize, _ctx.getFullWidth, _ctx.getTextAndIcons, _ctx.getProcessing, _ctx.getLoopAnimation]]),
    type: "button",
    disabled: _ctx.disabled
  }, [
    (_ctx.isButtonIconVisible)
      ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          class: _normalizeClass(_ctx.buttonIconClasses),
          "aria-hidden": "true"
        }, null, 2))
      : _createCommentVNode("", true),
    (_ctx.processing)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _cache[0] || (_cache[0] = [
          _createElementVNode("circle", {
            class: "opacity-25",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            "stroke-width": "4"
          }, null, -1),
          _createElementVNode("path", {
            class: "opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          }, null, -1)
        ])))
      : _createCommentVNode("", true),
    (_ctx.loopAnimation)
      ? (_openBlock(), _createElementBlock("span", {
          key: 2,
          class: _normalizeClass(["icon-right", _ctx.loopDirection == 'right' ? 'group-hover:translate-x-0' : 'group-hover:translate-x-8'])
        }, _cache[1] || (_cache[1] = [
          _createElementVNode("i", {
            class: "ri-arrow-right-line",
            "aria-hidden": "true"
          }, null, -1)
        ]), 2))
      : _createCommentVNode("", true),
    (_ctx.loopAnimation)
      ? (_openBlock(), _createElementBlock("span", {
          key: 3,
          class: _normalizeClass(["icon-left", _ctx.loopDirection == 'right' ? 'group-hover:-translate-x-8' : 'group-hover:translate-x-0'])
        }, _cache[2] || (_cache[2] = [
          _createElementVNode("i", {
            class: "ri-arrow-right-line",
            "aria-hidden": "true"
          }, null, -1)
        ]), 2))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: _normalizeClass([{ 'sr-only': _ctx.hasOnlyIcon }, { 'loop-text': _ctx.loopAnimation }])
    }, _toDisplayString(_ctx.text), 3),
    (_ctx.hasTextAndIcon && _ctx.rightIcon)
      ? (_openBlock(), _createElementBlock("i", {
          key: 4,
          class: _normalizeClass(["ml-2", _ctx.rightIcon]),
          "aria-hidden": "true"
        }, null, 2))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}